// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Campagne css*/
.Campagne-card-buttons {
  background-color: transparent;
  box-shadow: none;
}
.Campagne-card-filter {
  box-shadow: none;
}
.my-custom-class-btn-style {
  border-radius: 6px;
  padding: 20px;
  text-transform: uppercase;
  width: 100%;
  font-size: medium;
  display: flex;
  align-items: center;
  justify-content: center;
}
.my-custom-class-btn-style .icon-campagne {
  font-size: 30px;
}
input[type="checkbox"] {
  width: 20px;
  height: 20px;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/utils/Css/Campagne.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/*Campagne css*/\n.Campagne-card-buttons {\n  background-color: transparent;\n  box-shadow: none;\n}\n.Campagne-card-filter {\n  box-shadow: none;\n}\n.my-custom-class-btn-style {\n  border-radius: 6px;\n  padding: 20px;\n  text-transform: uppercase;\n  width: 100%;\n  font-size: medium;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.my-custom-class-btn-style .icon-campagne {\n  font-size: 30px;\n}\ninput[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
